
export function is<T>(left: T, right: T): boolean;
export function is(left: number, right: number): boolean;
export function is<T>(left: T | number, right: T | number): boolean {
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
  if (left === right) {
    // If `left === right`, then differentiate `-0` and `0` via division.
    return left !== 0 || 1 / left === 1 / <number>right;
  } else {
    // If `left !== right`, then return false unless both `left` and `right` are `NaN`.
    // `NaN` can be detected via `self !== self`.
    return left !== left && right !== right;
  }
}
